(function ($, Drupal) {
  /**
   * Indicates filter state for selected option.
   *
   * @type {boolean}
   * @private
   */
  const _filtered = false;

  Drupal.behaviors.dlmenu = {
    attach: function attach(context, settings) {
      const regionSelector = "#dl-menu";
      const collapseSelector = "#filterResultsCollapse";

      $(regionSelector, context).dlmenu();

      Drupal.behaviors.searchFilterUtils.checkFiltersFromParameters(
        regionSelector
      );
      Drupal.behaviors.searchFilterUtils.count(context);

      // Let to Stores value of group.
      let lastClicked = "";
      $(regionSelector, context)
        .find(".eprc-input")
        .click(() => {
          let el = $(this).closest("li");

          // When click to remove improbable result it apply class to disable this menu click.
          if (el.hasClass("item-unavailable")) {
            el.removeClass("item-unavailable").addClass("item-disabled");
          }
          // Stores the last group of clicked item on menu mobile.
          lastClicked = $(this).data("field");
          Drupal.behaviors.searchFilterUtils.count(context);
        });

      // Apply filter.
      $(regionSelector, context)
        .find(".apply")
        .click(() => {
          const url = Drupal.behaviors.searchFilterUtils.getUrl(
            context,
            regionSelector
          );
          // Pass correctly URL with "&last=" lastClicked value.
          url.queryString = url.queryString.replace(/&page(=[^&]*)?/g, "");
          Drupal.behaviors.searchFilter.filter(context, url, lastClicked);
          $(collapseSelector, context).collapse("hide");
          Drupal.behaviors.dlmenu.appliedFilter = true;
        });
    },

    /**
     * Get applied filter state.
     *
     * @returns {*}
     */
    get appliedFilter() {
      return Drupal.behaviors.dlmenu._filtered;
    },

    /**
     * Set state of applied filter.
     *
     * @param value
     *   Boolean value indicating the state.
     */
    set appliedFilter(value) {
      Drupal.behaviors.dlmenu._filtered = value;
    },
  };

  // Get URL
  const urlPledget = window.location.href;

  // Checks if Pledget exists in the url
  if (urlPledget.search(/Pledget/i) > 0) {
    $("#field_pledget_size_mobile").removeClass("hide");
  } else {
    $("#field_pledget_size_mobile").addClass("hide");
  }

  // Get change checkbox Special > Pledget
  $("input#field_special_input").change(function () {
    let pledgetChecked = $(this).prop("checked");

    // Checks if Pledget is checked
    if (pledgetChecked == false) {
      $("#field_pledget_size_mobile").addClass("hide");
    } else {
      $("#field_pledget_size_mobile").removeClass("hide");
    }
  });
})(jQuery, Drupal);
